import React, { useState } from "react";
import { Form, Image } from "react-bootstrap";
import "../../../Assets/css/myaccount.css";
import "../../../Assets/css/alicias.css";
import { Breadcrumbs, Link, Typography } from "@material-ui/core";
import TextField from "@mui/material/TextField";
import { Col, Container, Row } from "react-bootstrap";
import Button from "@mui/material/Button";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import { NavLink } from "react-router-dom";
import axios from "axios";
import {
  Address_details,
  base_url,
  media_details,
  postHeader,
} from "../../../Helpers/request";
import swal from "sweetalert";
// import { Helmet } from 'react-helmet';
import { useSelector } from "react-redux";

const QueryForm = () => {
  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  const [first_name, setFirst_name] = useState("");
  const [last_name, setLast_name] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [comment, setComment] = useState("");

  const formsubmit = (e) => {
    e.preventDefault();
    var data = {
      first_name,
      last_name,
      email,
      phone,
      comment,
    };
    axios
      .post(base_url + "/user/contact", data, {
        headers: postHeader,
      })
      .then((response) => {
        if (response.data.status == 1) {
          setFirst_name("");
          setLast_name("");
          setEmail("");
          setComment("");
          setPhone("");
          return swal(response.data.message, "", "success");
        } else {
          return swal(response.data.message, "", "error");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <>
      {/* <Helmet>
                <meta charSet="utf-8" />
                <title>{metaDetails.title}</title>
                <meta name="description" content={metaDetails.description}></meta>
                <meta name="keywords" content={metaDetails.keywords}></meta>
            </Helmet> */}
      <div className="rcs_myaccount_section ali_query_Form_section">
        {/* <Container>
                    <Row>
                        <Col className="rcs_breadcrumb mb-2">
                            <Breadcrumbs aria-label="breadcrumb">
                                <NavLink underline="hover" color="inherit" to="/">
                                    Home
                                </NavLink>
                                <Typography color="text.primary">Contact Us</Typography>
                            </Breadcrumbs>
                        </Col>
                    </Row>
                </Container> */}

        <div className="rcs_appointment mt-5 mb-5">
          <Container>
            <Row className="w-100 m-auto">
              <Col className="p-md-0 mb-5">
                <h3 className="text-center text-uppercase mb-0">
                  {/* Get in Touch */}
                  for Price details get in touch
                </h3>
              </Col>
            </Row>
            <Row className="w-100 m-auto">
              <Col
                sm={12}
                md={{ span: 8, offset: 2 }}
                lg={{ span: 6, offset: 3 }}
                className="p-md-0"
              >
                <Form onSubmit={formsubmit} className="ali_query_from">
                  <Row>
                    <Col xs={12} sm={6}>
                      <TextField
                        labelId="rcs_choose_type"
                        // id="demo-simple-select"
                        label="First Name"
                        type="text"
                        variant="outlined"
                        value={first_name}
                        onChange={(e) => setFirst_name(e.target.value)}
                        required
                      />
                    </Col>
                    <Col xs={12} sm={6}>
                      <TextField
                        labelId="rcs_choose_type"
                        // id="demo-simple-select"
                        label="Last Name"
                        type="text"
                        variant="outlined"
                        value={last_name}
                        onChange={(e) => setLast_name(e.target.value)}
                        required
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} sm={6}>
                      <TextField
                        labelId="rcs_choose_type"
                        // id="demo-simple-select"
                        label="Email Address"
                        type="Email"
                        variant="outlined"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </Col>
                    <Col xs={12} sm={6}>
                      <TextField
                        labelId="rcs_choose_type"
                        // id="demo-simple-select"
                        label="Phone"
                        type="number"
                        variant="outlined"
                        InputProps={{ inputProps: { min: 0 } }}
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        required
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <TextField
                        labelId="your-message"
                        aria-label="Your Message"
                        id="your-message"
                        // aria-labelledby="Your Message"
                        label="Your Message"
                        multiline
                        rows={4}
                        variant="outlined"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="text-center">
                      <Button aria-label="Submit"
                        variant="contained"
                        type="submit"
                        className="rcs_acc_button"
                      >
                        {" "}
                        Submit
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};

export default QueryForm;
